import React, { HTMLAttributes, useCallback } from 'react';

export interface InlineButtonProps extends HTMLAttributes<HTMLElement> {
  as?: React.ElementType<any>;
  onClick: (e: any, ...more: unknown[]) => void;
  [rest: string]: any;
}

export const InlineButton = ({ as, onClick, ...rest }: InlineButtonProps) => {
  const Element = as || 'span';
  const keyDown = useCallback(
    (event: React.KeyboardEvent<HTMLButtonElement>, ...more) => {
      if (onClick && (event.keyCode === 13 || event.keyCode === 32)) {
        event.preventDefault();
        onClick(event, ...more);
      }
    },
    [onClick],
  );

  return <Element tabIndex="0" role="button" onKeyDown={keyDown} onClick={onClick} {...rest} />;
};
